var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "fill-height align-start align-content-start" },
    [
      _c(
        "v-row",
        { staticClass: "mb-4 mt-12" },
        [
          _c(
            "v-col",
            {
              staticClass: "d-flex flex-row align-center",
              attrs: { cols: "12" },
            },
            [
              _c("a", { staticClass: "page-title", attrs: { href: "/" } }, [
                _vm._v("Модели"),
              ]),
              _c("h2", { staticClass: "page-title" }, [_vm._v("Расчеты")]),
            ]
          ),
        ],
        1
      ),
      _c(
        "v-row",
        {
          attrs: {
            align: "start",
            justify: _vm.isEmpty || _vm.isLoading ? "center" : "start",
          },
        },
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-data-table", {
                attrs: {
                  dense: "",
                  dark: "",
                  headers: _vm.headers,
                  items: _vm.items,
                  loading: _vm.isLoading,
                  "items-per-page": _vm.itemsPerPage,
                  "multi-sort": "",
                  "sort-by": ["created"],
                  "sort-desc": [true],
                  locale: "ru",
                  "footer-props": {
                    "items-per-page-options": [5, 15, 50, 100, 500, -1],
                  },
                },
                on: {
                  "update:items-per-page": function (newValue) {
                    return (_vm.itemsPerPage = newValue)
                  },
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.type",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm._v(" " + _vm._s(_vm.getTypeTitle(item)) + " "),
                      ]
                    },
                  },
                  {
                    key: "item.status",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _c(
                          "div",
                          { staticClass: "table-status" },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.getStatusText(item))),
                            ]),
                            _c("task-progress", {
                              attrs: {
                                task: item,
                                color: "white",
                                circular: "",
                                size: "20",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.actions",
                    fn: function (ref) {
                      var item = ref.item
                      return [
                        _vm.canEdit(item)
                          ? _c(
                              "v-btn",
                              {
                                attrs: { icon: "", small: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.gotoEdit(item)
                                  },
                                },
                              },
                              [_c("v-icon", [_vm._v("mdi-pencil")])],
                              1
                            )
                          : _vm._e(),
                        _vm.isCalculationReady(item)
                          ? _c(
                              "v-btn",
                              {
                                attrs: { icon: "", small: "" },
                                on: {
                                  click: function ($event) {
                                    return _vm.gotoCalculations(item)
                                  },
                                },
                              },
                              [_c("v-icon", [_vm._v("mdi-eye")])],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "v-btn",
                          {
                            staticClass: "ml-4",
                            attrs: { icon: "", small: "" },
                            on: {
                              click: function ($event) {
                                return _vm.deleteItem(item)
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("mdi-delete")])],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }